export const redColors = [{
    hexCode: "#FF6263",
    colorName: "BitterSweet",
},
{
    hexCode: "#DE4839",
    colorName: "Punch"
},
{
    hexCode: "#BF3325",
    colorName: "Tall Poppy"
},
{
    hexCode: "#E21717",
    colorName: "Alizarin Crimson"
},
{
    hexCode: "#BF3312",
    colorName: "Rust"
},
{
    hexCode: "#D82E2F",
    colorName: "Punch"
},
{
    hexCode: "#EB4D4B",
    colorName: "Cinnabar"
},
{
    hexCode: "#EF5354",
    colorName: "Burnt Siena"
},
{
    hexCode: "#B4161B",
    colorName: "Thunderbird"
},
{
    hexCode: "#E6425E",
    colorName: "Mandy"
},
{
    hexCode: "#E83A59",
    colorName: "Amaranth"
},
{
    hexCode: "#B9345A",
    colorName: "Hisbiscus"
}
];

export const blueColor = [{
    blueColorHexCode: "#1B98F5",
    colorName: "Dogder Blue"
},
{
    blueColorHexCode: "#23C4ED",
    colorName: "Picton Blue"
},
{
    blueColorHexCode: "#383CC1",
    colorName: "Governor Bay"
},
{
    blueColorHexCode: "#12B0E8",
    colorName: "Cerulean"
},
{
    blueColorHexCode: "#51E1ED",
    colorName: "Turquiose Blue"
},
{
    blueColorHexCode: "#207398",
    colorName: "Matisse"
},
{
    blueColorHexCode: "#46B2E0",
    colorName: "Picton Blue"
},
{
    blueColorHexCode: "#3944F7",
    colorName: "Blue Ribbon"
},
{
    blueColorHexCode: "#2827CC",
    colorName: "Persian Blue"
},
{
    blueColorHexCode: "#120E43",
    colorName: "Blue Zodiac"
},
{
    blueColorHexCode: "#5DA3FA",
    colorName: "Cornflower Blue"
},
{
    blueColorHexCode: "#03203C",
    colorName: "Tangaroa"
}
];

export const greenColor = [{
    greenColorHexCode: "#1FAA59",
    colorName: "Mountain Meadow"
},
{
    greenColorHexCode: "#38CC77",
    colorName: "Emerald"
},
{
    greenColorHexCode: "#02B290",
    colorName: "Persian Green"
},
{
    greenColorHexCode: "#50DBB4",
    colorName: "Turquiose"
},
{
    greenColorHexCode: "#3DBE29",
    colorName: "Apple"
},
{
    greenColorHexCode: "#4DD637",
    colorName: "Atlantis"
},
{
    greenColorHexCode: "#1C8D73",
    colorName: "Elm"
},
{
    greenColorHexCode: "#66AD47",
    colorName: "Apple"
},
{
    greenColorHexCode: "#6AC47E",
    colorName: "De York"
},
{
    greenColorHexCode: "#6EC72D",
    colorName: "Atlantis"
},
{
    greenColorHexCode: "#22CB5C",
    colorName: "Mountain Meadow"
},
{
    greenColorHexCode: "#00D84A",
    colorName: "Malachite"
}
];

export const yellowColor = [{
    yellowColorHexCode: "#E8BD0D",
    colorName: "Galliona"
}, {
    yellowColorHexCode: "#EDBF69",
    colorName: "Porsche"
}, {
    yellowColorHexCode: "#F4BE2C",
    colorName: "Saffron"
},
{
    yellowColorHexCode: "#EDC126",
    colorName: "Golden Dream"
},
{
    yellowColorHexCode: "#E5D68A",
    colorName: "Putty"
},
{
    yellowColorHexCode: "#DDD101",
    colorName: "Corn"
},
{
    yellowColorHexCode: "#D9D55B",
    colorName: "Tacha"
},
{
    yellowColorHexCode: "#F7CD2E",
    colorName: "Saffron"
},
{
    yellowColorHexCode: "#AF9D5A",
    colorName: "Teak"
},
{
    yellowColorHexCode: "#C7C11A",
    colorName: "Key Lime Pie"
},
{
    yellowColorHexCode: "#F4CE6A",
    colorName: "Cream Can"
},
{
    yellowColorHexCode: "#A77B06",
    colorName: "Hot Toddy"
}
]

export const mixColors = [{
    mixColorsHexCode: "#8D3DAF",
    colorName: "Royal Purple"
}, {
    mixColorsHexCode: "#E07C24",
    colorName: "Zest"
}, {
    mixColorsHexCode: "#758283",
    colorName: "Sirocco"
},
{
    mixColorsHexCode: "#E03B8B",
    colorName: "Cerise"
},
{
    mixColorsHexCode: "#FF6666",
    colorName: "Bittersweet"
},
{
    mixColorsHexCode: "#242B2E",
    colorName: "Outer Space"
},
{
    mixColorsHexCode: "#03C6C7",
    colorName: "Robin's Egg Blue"
},
{
    mixColorsHexCode: "#5A20CB",
    colorName: "Purple Heart"
},
{
    mixColorsHexCode: "#6A1B4D",
    colorName: "Tawny Port"
},
{
    mixColorsHexCode: "#CAD5E2",
    colorName: "Botticelli"
},
{
    mixColorsHexCode: "#35BDD0",
    colorName: "Scooter"
},
{
    mixColorsHexCode: "#0D0D0D",
    colorName: "Code Gray"
}
]
export const colors = [
    {
        colorId: 0,
        code: "rgb(23, 30, 69)",
    },
    {
        colorId: 1,
        code: "#BF3325",
    },
    {
        colorId: 2,
        code: "#1FAA59",
    },
    {
        colorId: 3,
        code: "#383CC1",
    },

    {
        colorId: 4,
        code: "#E8BD0D",
    },
    {
        colorId: 5,
        code: "#6A1B4D",
    },
];

export const gradientColors = [
    {
        gradientColorCodes: "#9896f0, #fbc8d5",
    },
    {
        gradientColorCodes: "#71c5ee, #025091",
    },
    {
        gradientColorCodes: "#fbee97, #adedd5",
    },
    {
        gradientColorCodes: "#ff7082, #c0e955",
    },
    {
        gradientColorCodes: "#bcc5ce, #9e9fae",
    },
    {
        gradientColorCodes: "#626262, #9bc5c3",
    },
    {
        gradientColorCodes: "#dbd5ed, #f3e7ea",
    },
    {
        gradientColorCodes: "#fdfcfb, #e3d2c4",
    },
    {
        gradientColorCodes: "#FED54A, #FF9347",
    },
    {
        gradientColorCodes: "#EFF54D, #00AC61",
    },
    {
        gradientColorCodes: "#538FFB, #5B54FA",
    },
    {
        gradientColorCodes: "#FD297A, #9424F0",
    },
    {
        gradientColorCodes: "#253898, #5737D6",
    },
    {
        gradientColorCodes: "#FF4331, #D31A50",
    },
    {
        gradientColorCodes: "#DB0B5F, #6F00ED",
    },
    {
        gradientColorCodes: "#E1A2B8, #9F2BC1",
    }
]

export const premiumColors = [
    {
        premiumColorHexCode: "#171e45",
        colorName: "Midnight Blue"
    },
    {
        premiumColorHexCode: "#e85e04",
        colorName: "Burnt Orange"
    },
    {
        premiumColorHexCode: "#91cde2",
        colorName: "Pastel Blue"
    },
    {
        premiumColorHexCode: "#f6c35d",
        colorName: "Sunflower Yellow"
    },
    {
        premiumColorHexCode: "#111111",
        colorName: "Premium Gray"

    },
    {
        premiumColorHexCode: "#2F2F2F",
        colorName: "Night Rider"

    },
    {
        premiumColorHexCode: "#F6F6F6",
        colorName: "White Smoke"

    },
    {
        premiumColorHexCode: "#FEFEFE",
        colorName: "Premium White"

    },
    {
        premiumColorHexCode: "#FFCB74",
        colorName: "Grandis"

    },
    {
        premiumColorHexCode: "#B38B59",
        colorName: "Barley Corn"

    },
    {
        premiumColorHexCode: "#113E21",
        colorName: "Deep Fir"

    },
    {
        premiumColorHexCode: "#F0F0F0",
        colorName: "White Smoke 2"

    },
    {
        premiumColorHexCode: "#3B3B3B",
        colorName: "Eclipse"

    },
    {
        premiumColorHexCode: "#050206",
        colorName: "Black Currant"

    },
    {
        premiumColorHexCode: "#9A8174",
        colorName: "Hemp"

    },
    {
        premiumColorHexCode: "#FFFFFF",
        colorName: "Pure White"

    },
    {
        premiumColorHexCode: "#FFE6BC",
        colorName: "Moccasin"

    },
    {
        premiumColorHexCode: "#F7F1EA",
        colorName: "Linen"

    },
    {
        premiumColorHexCode: "#302A18",
        colorName: "Maire"

    },
    {
        premiumColorHexCode: "#FDE4C3",
        colorName: "Bisque"

    }
]

export const colorShades = [
    {
        colorName: "all shades",
        colorId: 0,
        colorCode: "#e6f0ff"
    },
    {
        colorName: "red",
        colorId: 1,
        colorCode: "#ff2929"
    },
    {
        colorName: "orange",
        colorId: 2,
        colorCode: "#ff7a29"
    },
    {
        colorName: "purple",
        colorId: 3,
        colorCode: "#991ef9"
    },
    {
        colorName: "aqua",
        colorId: 4,
        colorCode: "#36d8b7"
    },
    {
        colorName: "pink",
        colorId: 5,
        colorCode: "#ff5dcd"
    },
    {
        colorName: "green",
        colorId: 6,
        colorCode: "#91fa49"
    },
    {
        colorName: "yellow",
        colorId: 7,
        colorCode: "#fad02e"
    },
    {
        colorName: "lime",
        colorId: 8,
        colorCode: "#bfff00"
    },
    {
        colorName: "navy",
        colorId: 9,
        colorCode: "#000080"
    },
    {
        colorName: "blue",
        colorId: 10,
        colorCode: "#3b8aff"
    },

]